/**
 * 素材元数据
 */

export const taskSearchField = [
  {
    value: 'creative_id',
    label: '创意方向id'
  },
  {
    value: 'creative_name',
    label: '创意方向名称'
  },
  {
    value: 'creative_spec',
    label: '创意说明'
  },
  {
    value: 'demand_id',
    label: '需求ID'
  },
  {
    value: 'demand_name',
    label: '需求名称'
  },
  {
    value: 'app_name',
    label: '产品名称'
  },
  {
    value: 'id',
    label: '测试任务ID'
  },
  {
    value: 'basic_id',
    label: '基础包ID'
  },
  {
    value: 'mid',
    label: 'Mid'
  },
  {
    value: 'package_name',
    label: 'App包名'
  }
]

export const platform = [
  {
    value: 'ios',
    label: 'iOS'
  },
  {
    value: 'android',
    label: 'Android'
  }
]

export const clickConfList = [
  {
    value: 1,
    label: '全局可点'
  },
  {
    value: 2,
    label: 'store kit'
  },
  {
    value: 3,
    label: 'normal'
  }
]

export const priority = [
  {
    value: 4,
    label: '紧急'
  }, {
    value: 3,
    label: '高'
  }, {
    value: 2,
    label: '中'
  }, {
    value: 1,
    label: '低'
  }
]

export const testStatus = [ // value 5和6曾经有用。但是删除了
  {
    value: 1,
    label: '测试中'
  }, {
    value: 2,
    label: '测试通过'
  }, {
    value: 3,
    label: '待重测'
  }, {
    value: 7,
    label: '待测试'
  }, {
    value: 8,
    label: '自测'
  }, {
    value: 9,
    label: '已发布'
  }, {
    value: 10,
    label: '待压缩审核'
  }, {
    value: 11,
    label: '压缩不合格'
  }, {
    value: 12,
    label: '提测失败'
  }, {
    value: 13,
    label: '待广告主审核'
  }, {
    value: 14,
    label: '已作废'
  }, {
    value: 15,
    label: '测试不通过'
  }
]

export const orientation = [
  {
    value: 1,
    label: '横屏'
  },
  {
    value: 2,
    label: '竖屏'
  },
  {
    value: 3,
    label: '自适应'
  }
]

export const closeTime = [
  {
    value: 3,
    label: '3秒'
  },
  {
    value: 15,
    label: '15秒'
  }
]

export const logoPosition = [
  {
    value: 1,
    label: '左'
  },
  {
    value: 2,
    label: '中'
  },
  {
    value: 3,
    label: '右'
  }
]

export const categories = [
  {
    value: 1,
    label: 'interactive endcard'
  },
  {
    value: 2,
    label: 'playable2d'
  },
  {
    value: 3,
    label: 'playable3d'
  },
  {
    value: 4,
    label: 'interactive video'
  },
  {
    value: 5,
    label: 'panoramic'
  }
]

export const chooseIfOptions = [
  {
    value: 1,
    label: '是'
  },
  {
    value: 0,
    label: '否'
  }
]

export const compressOptions = [
  {
    value: 3,
    label: '自动'
  },
  {
    value: 2,
    label: '否'
  }
]

export const renderType = [
  {
    value: 1,
    label: '前置渲染'
  },
  {
    value: 2,
    label: '后置渲染'
  }
]

export const priorityOptions = [
  {
    value: 1,
    label: '低'
  },
  {
    value: 2,
    label: '中'
  },
  {
    value: 3,
    label: '高'
  },
  {
    value: 4,
    label: '紧急'
  }
]

export const materialSourceType = [
  {
    value: 1,
    label: '在线制作'
  },
  {
    value: 2,
    label: '交互视频'
  },
  {
    value: 3,
    label: '模版提测'
  }
]

export const appSource = [
  {
    value: 'Google Play',
    label: 'Google Play'
  },
  {
    value: 'App Store',
    label: 'App Store'
  },
  {
    value: 'Website',
    label: 'Website'
  }
]

export const timeFilterOptions = [
  {
    value: 'created_time',
    label: '按提测日期'
  },
  {
    value: 'updated_time',
    label: '按更新日期'
  }
]

export const stageOptions = [{
  value: 'start',
  label: 'start'
}, {
  value: 'ending',
  label: 'ending'
}]
